export default {
  new: "new",
  pending: "pending",
  processing: "processing",
  canceled: "canceled",
  paid: "paid",
};
